import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Heart } from 'lucide-react';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="flex flex-wrap items-center justify-between gap-2 border-t border-[color:var(--inst-player-border,#e5e7eb)] bg-[color:var(--inst-player-surface,#ffffff)] px-4 py-3 text-xs text-[color:var(--inst-player-text-muted,#6b7280)] dark:border-[hsl(217,33%,22%)] dark:text-[#B6CAEC]">
      <p className="flex items-center gap-1 text-xs leading-normal">
        © {year} LyrraStudio.
        <span className="hidden sm:inline">
          {t('footer.madeWith', 'Made with')}
          <Heart className="inline h-3 w-3 mx-0.5 text-red-500 fill-red-500" aria-hidden />
          {t('footer.forEducation', 'for education')}
        </span>
      </p>

      <nav className="flex items-center gap-4 text-xs" aria-label={t('footer.legal', 'Legal links')}>
        <Link
          to="/terms"
          className="text-xs transition-colors hover:text-[color:var(--inst-player-primary,#0C1C38)] dark:hover:text-[color:color-mix(in_srgb,var(--inst-player-primary,#0C1C38)_85%,#fff)]"
        >
          {t('footer.terms', 'Terms')}
        </Link>
        <Link
          to="/privacy"
          className="text-xs transition-colors hover:text-[color:var(--inst-player-primary,#0C1C38)] dark:hover:text-[color:color-mix(in_srgb,var(--inst-player-primary,#0C1C38)_85%,#fff)]"
        >
          {t('footer.privacy', 'Privacy')}
        </Link>
        <Link
          to="/accessibility"
          className="text-xs transition-colors hover:text-[color:var(--inst-player-primary,#0C1C38)] dark:hover:text-[color:color-mix(in_srgb,var(--inst-player-primary,#0C1C38)_85%,#fff)]"
        >
          {t('footer.accessibility', 'Accessibility')}
        </Link>
      </nav>
    </footer>
  );
}

export default Footer;
